import React from 'react';
import { useLocation } from 'react-router-dom';
import { useGrowthStandupDialog } from '@/contexts/GrowthStandupDialogContext';
import { DayStartDialog } from './DayStartDialog';
import { DayEndDialog } from './DayEndDialog';
import { useGrowthStandup } from '@/hooks/useGrowthStandup';

export const GlobalGrowthStandupDialogs: React.FC = () => {
  const location = useLocation();
  const { isDayStartOpen, isDayEndOpen, closeDayStart, closeDayEnd } = useGrowthStandupDialog();
  
  // Single shared hook instance for both dialogs
  const standupHook = useGrowthStandup();

  // On /growth-plan, the page renders the modals. Avoid duplicates elsewhere.
  if (location.pathname === '/growth-plan') {
    return null;
  }

  return (
    <>
      <DayStartDialog
        open={isDayStartOpen}
        onOpenChange={(open) => !open && closeDayStart()}
        onComplete={() => standupHook.refetch()}
      />
      <DayEndDialog
        open={isDayEndOpen}
        onOpenChange={(open) => !open && closeDayEnd()}
        standupHook={standupHook}
      />
    </>
  );
};
